// extracted by mini-css-extract-plugin
module.exports = {"head":"ChatLoader_head__1sTZz","loader":"ChatLoader_loader__o2TY4","sender":"ChatLoader_sender__1_3Rd","reciver":"ChatLoader_reciver__21Ni1"};